/* 🤖 this file was generated by svg-to-ts */
export const DfIconFlag16: {
  name: 'flag-16';
  data: string;
} = {
  name: 'flag-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M2 0a1 1 0 0 1 1 1v15H1V1a1 1 0 0 1 1-1zm3.448 1.635C6.088 1.212 6.938 1 8 1c2 0 1.998 2 4 2 .644 0 1.21-.078 1.697-.233A1 1 0 0 1 15 3.721v5.81a1 1 0 0 1-.448.834c-.64.423-1.49.635-2.552.635-1.998 0-2.003-2-4-2-.643 0-1.208.078-1.697.233A1 1 0 0 1 5 8.28V2.47a1 1 0 0 1 .448-.834z" fill-rule="evenodd"/></svg>`
};
